import { render } from "./TransactionTypeManual.vue?vue&type=template&id=658137db&scoped=true"
import script from "./TransactionTypeManual.vue?vue&type=script&lang=js"
export * from "./TransactionTypeManual.vue?vue&type=script&lang=js"

import "./TransactionTypeManual.vue?vue&type=style&index=0&id=658137db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-658137db"

export default script